const yup = require('yup')
const mobileUserTypes = require('../mobile-user-types')
const { requiredFields, labelify } = require('./helpers')
const levelsOfCare = require('../levels-of-care')
const utils = require('./../../shared/utils')

const { calculateMonthTargetWithOverrides } = utils

const testOverrideMonthlyPercentDistribution = async function (overrides = {}) {
  const labels = this.options.context?.labels || []
  const { percent = 0, count = 0 } = calculateMonthTargetWithOverrides(labels, overrides)
  return count > 0 ? percent === 100 : true
}

const shape = labelify({
  name: yup.string().default(''),
  details: yup.string().default(''),
  resort: yup.mixed(),
  restrictToUserType: yup.string().oneOf(mobileUserTypes.concat('')).ensure(),
  displayOnFeedScreen: yup.boolean().default(true),
  icalImport: yup.object().shape({
    url: yup
      .string()
      .nullable()
      .transform((v) => v || null),
    active: yup.boolean().default(false),
  }),
  eventTypesOverride: yup.mixed().default({}),
  levelsOfCare: yup.array().of(yup.string().oneOf(levelsOfCare).nullable()).default([]),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
  createdAt: yup.date(),
  updatedAt: yup.date(),
})

const calendarSchemaPartial = yup.object().shape(shape)
const calendarSchema = calendarSchemaPartial.shape(requiredFields(['name'])(shape))

const calendarResponseSchema = calendarSchema.shape({
  icalImport: yup.object().shape({
    url: yup.string().ensure(),
    active: yup.boolean().default(false),
    lastImportedAt: yup.date().nullable(),
    lastImportStatus: yup.string().nullable(),
    lastImportMessage: yup.string().nullable(),
  }),
  eventTypesOverride: yup.mixed().test('is-total-distribution-100', 'Invalid monthly distribution', testOverrideMonthlyPercentDistribution).default({}),
})

const calendarFormSchema = calendarResponseSchema

module.exports = { calendarSchema, calendarSchemaPartial, calendarResponseSchema, calendarFormSchema }
